import * as legacyTopicsApi from "api/legacy_topics";
import { Topic } from "types/topic";

import { useState, useEffect } from "react";
import { useQuery } from "react-query";

export function useTopics(parentTopic?: Topic) {
  const parentSlug = parentTopic?.slug;
  const [topics, setTopics] = useState([]);
  const [subTopics, setSubTopics] = useState([]);

  const { data } = useQuery("topics", legacyTopicsApi.index, {
    refetchOnWindowFocus: false,
    staleTime: 10 * 60 * 1000 // 10 minutes
  });

  useEffect(() => {
    if (!data) return;

    const newTopics = data.body.map(topicInfo);
    setTopics(newTopics);
    if (!parentSlug) return setSubTopics([]);

    const parentTopic = data.body.find((topic) => topic.slug === parentSlug);
    setSubTopics(parentTopic.children.map(topicInfo));
  }, [data, parentSlug]);

  return [topics, subTopics];
}

export function useExam() {
  return { institutions, years, languages, testDays };
}

function topicInfo(topic) {
  const { name, slug } = topic;
  return { name, slug };
}

const institutions = [
  "ENEM",
  ...[
    "Fuvest",
    "UFPR",
    "UNESP",
    "Unicamp",
    "UNICENTRO",
    "UFSC",
    "UFRGS",
    "PUC-SP",
    "PUC-Rio"
  ].sort()
];

const years = Array.from(
  { length: new Date().getFullYear() - 2010 },
  (_, i) => new Date().getFullYear() - 1 - i
);

const languages = [
  { label: "Inglês", value: "ingles" },
  { label: "Espanhol", value: "espanhol" }
];

const testDays = [
  { label: "1º dia (Ciências humanas)", value: 1 },
  { label: "2º dia (Ciências exatas)", value: 2 }
];
